import React, { useState } from "react";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { useFormik } from "formik";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  Input,
  Label,
} from "components/ui";
import {
  AddCurrencyAction,
  UpdateCurrencyAction,
} from "store/middlewares/dataManagement/currency";
import { SubmitLoaderButton } from "components/atoms";

function ModalEditCurrency({ row }) {
  const dispatch = useDispatch();
  const [formError, setFormError] = useState(false);

  const handleSubmit = (values) => {
    setFormError(false);
    if (row) {
      dispatch(
        UpdateCurrencyAction({
          id: row.id,
          ...values,
          onSuccess: () => {
            formik.setSubmitting(false);
          },
          onError: () => {
            setFormError(true);
            formik.setSubmitting(false);
          },
        }),
      );
    } else {
      dispatch(
        AddCurrencyAction({
          ...values,
          filter: { page: 1, pageSize: 10 },
          onSuccess: () => {
            formik.setSubmitting(false);
          },
          onError: () => {
            setFormError(true);
            formik.setSubmitting(false);
          },
        }),
      );
    }
  };

  const formik = useFormik({
    initialValues: {
      name: row?.name ? row?.name : "",
      code: row?.code ? row?.code : "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Currency name is required"),
      code: Yup.string().required("Currency symbol is required"),
    }),
    enableReinitialize: true,
    onSubmit: handleSubmit,
  });

  return (
    <form onSubmit={formik.handleSubmit}>
      <div className="grid gap-5 lg:gap-7.5 mx-auto">
        <Card className="min-w-full">
          <CardHeader>
            <CardTitle>Currency</CardTitle>
          </CardHeader>
          <CardContent className="grid gap-5">
            <div className="flex items-baseline flex-wrap lg:flex-nowrap gap-2.5">
              <Label className="flex w-full max-w-56">Name</Label>
              <Input
                error={formik.errors.name && formik.touched.name}
                errorMsg={formik.errors.name}
                value={formik.values.name}
                type="text"
                name="name"
                maxLength={50}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                isTextOnly={true}
                placeholder="Enter name"
                className={"!py-0 w-full"}
              />
            </div>
            <div className="flex items-baseline flex-wrap lg:flex-nowrap gap-2.5">
              <Label className="flex w-full max-w-56">Symbol</Label>
              <Input
                error={formik.errors.code && formik.touched.code}
                errorMsg={formik.errors.code}
                value={formik.values.code}
                type="text"
                name="code"
                maxLength={3}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                /*   isTextOnly={true} */
                isUpperCase={true}
                suggestions={"off"}
                placeholder="Enter symbol"
                className={"!py-0 w-full"}
              />
            </div>
            <div className="flex justify-center">
              <SubmitLoaderButton
                type="submit"
                btnText={row ? "Update" : "Add"}
                isDisable={formik.isSubmitting && !formError}
              />
            </div>
          </CardContent>
        </Card>
      </div>
    </form>
  );
}

export default ModalEditCurrency;
